"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUTCEndOfDay = exports.toUTCStartOfDay = exports.toLotteryTimeZone = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var constants_1 = __importDefault(require("./../config/constants"));
var toLotteryTimeZone = function (date, format) {
    var momentDate = (0, moment_timezone_1.default)(date);
    var lotteryTimezoneDate = momentDate.tz(constants_1.default.LOTTERY_TIME_ZONE);
    return lotteryTimezoneDate.format(format);
};
exports.toLotteryTimeZone = toLotteryTimeZone;
var toUTCStartOfDay = function (date) {
    var utcDateTime = date.clone().tz(constants_1.default.LOTTERY_TIME_ZONE)
        .startOf('day')
        .clone()
        .utc()
        .toISOString();
    return utcDateTime;
};
exports.toUTCStartOfDay = toUTCStartOfDay;
var toUTCEndOfDay = function (date) {
    var utcDateTime = date.clone().tz(constants_1.default.LOTTERY_TIME_ZONE)
        .endOf('day')
        .clone()
        .utc()
        .toISOString();
    return utcDateTime;
};
exports.toUTCEndOfDay = toUTCEndOfDay;
//# sourceMappingURL=dateUtils.js.map